package features.home.ui.components

import kotlinx.html.*
import kotlinx.html.js.onClickFunction
import AppState
import features.attendance.helpers.AttendanceHelpers
import shared.ui.ModalManager

object UserAttendanceCard {
    fun render(parent: DIV, teamId: String) {
        val userId = AppState.currentUser?.id ?: return
        val team = AppState.teams.find { it.id == teamId } ?: return
        
        val (startTime, endTime) = AttendanceHelpers.getWorkHoursForUser(userId, teamId)
        val shift = AttendanceHelpers.getUserShiftForToday(userId, teamId)
        val attendanceStatus = AttendanceHelpers.getAttendanceStatus(userId, teamId)
        val todayRecord = AttendanceHelpers.getTodayAttendance(userId, teamId)
        val isLate = AttendanceHelpers.isLate(userId, teamId)
        
        parent.div("bg-gradient-to-br from-brand-cyan/20 to-violet-500/20 p-6 rounded-2xl border border-brand-cyan/30 mb-8 relative overflow-hidden") {
            // Header
            div("flex justify-between items-start mb-4") {
                div {
                    h3("text-xl font-bold mb-1") { +"Today's Attendance" }
                    p("text-slate-400 text-sm") {
                        val todayDate = AttendanceHelpers.getTodayDate()
                        +todayDate
                    }
                }
                
                
                // Status Badge
                val (statusText, statusClass) = when (attendanceStatus) {
                    "clocked_out" -> Pair("Completed", "bg-emerald-500/20 text-emerald-400")
                    "clocked_in" -> Pair("Clocked In", "bg-blue-500/20 text-blue-400")
                    else -> Pair("Not Started", "bg-slate-500/20 text-slate-400")
                }
                
                span("px-3 py-1 rounded-full text-xs font-bold $statusClass") {
                    +statusText
                }
            }
            
            // Work Hours Info
            div("bg-dark-800/50 p-4 rounded-xl mb-4 border border-dark-700") {
                div("flex items-center justify-between mb-3") {
                    div("flex items-center gap-2") {
                        span("text-2xl") { +"⏰" }
                        div {
                            p("text-sm text-slate-400") {
                                if (shift != null && shift.code != "OFF") {
                                    +"Shift: ${shift.code}"
                                } else {
                                    +"Default Work Hours"
                                }
                            }
                            p("text-lg font-bold") {
                                +"$startTime - $endTime"
                            }
                        }
                    }
                }
                
                // Clock In/Out Status
                div("grid grid-cols-2 gap-4") {
                    div {
                        p("text-xs text-slate-400 mb-1") { +"Clock In" }
                        p("font-bold ${if (isLate) "text-amber-400" else "text-emerald-400"}") {
                            if (todayRecord?.checkIn != null && todayRecord.checkIn != "-") {
                                +todayRecord.checkIn
                                if (isLate) {
                                    span("text-xs ml-1") { +"(Late)" }
                                }
                            } else {
                                +"--:--"
                            }
                        }
                    }
                    div {
                        p("text-xs text-slate-400 mb-1") { +"Clock Out" }
                        p("font-bold text-slate-300") {
                            if (todayRecord?.checkOut != null && todayRecord.checkOut != "-") {
                                +todayRecord.checkOut
                            } else {
                                +"--:--"
                            }
                        }
                    }
                }
            }
            
            // Action Buttons
            div("flex gap-3") {
                when (attendanceStatus) {
                    "not_clocked_in" -> {
                        button(classes = "flex-1 bg-brand-cyan hover:bg-brand-green text-white px-6 py-3 rounded-xl font-bold transition flex items-center justify-center gap-2") {
                            onClickFunction = { 
                                AppState.currentTeam = team
                                ModalManager.show("clock-in-modal")
                            }
                            span { +"🚀" }
                            +"Clock In"
                        }
                    }
                    "clocked_in" -> {
                        button(classes = "flex-1 bg-violet-500 hover:bg-violet-600 text-white px-6 py-3 rounded-xl font-bold transition flex items-center justify-center gap-2") {
                            onClickFunction = { 
                                AppState.currentTeam = team
                                ModalManager.show("clock-in-modal")
                            }
                            span { +"🏁" }
                            +"Clock Out"
                        }
                    }
                    "clocked_out" -> {
                        div("flex-1 bg-dark-700/50 text-slate-400 px-6 py-3 rounded-xl font-bold text-center border border-dark-600") {
                            +"✅ Attendance Complete"
                        }
                    }
                }
                
                // View Details Button
                button(classes = "bg-dark-700 hover:bg-dark-600 text-white px-6 py-3 rounded-xl font-medium transition border border-slate-600") {
                    onClickFunction = {
                        // Navigate to team detail attendance tab
                        AppState.currentPage = "team-detail"
                        AppState.currentTeam = team
                        AppState.currentTab = "attendance"
                        Router.render()
                    }
                    +"View Details"
                }
            }
        }
    }
}
